
class Menu{
    defaultOptions() {
        return {
        	'btnCollapseSelector' : '.header__menu__btn_collapse',
        	'menuSelector': '.header__menu',

        	'listClass': 'header__menu--list',
        	'menuLinkClass': 'header__menu--top--item--link',
        	'menuContentClass': 'header__menu--main',
        	'pageLinkClass': 'header__menu--link',
        	'pageSubLinkClass': 'header__menu--sublink',
			'menuSecondLevel': '.header__menu--main-items',
			'menuLastLevel': '.header__menu--main-items-sub',
        	'pageContentClass': 'header__menu--main-item',

        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickCollapse = this.onClickCollapse.bind(this);
        this.onClickMenuLink = this.onClickMenuLink.bind(this);


        this.$btnCollapse = $(this.settings.btnCollapseSelector);
        this.$menuContainer = $(this.settings.menuSelector);
		this.$menuSecondContainer = $(this.settings.menuSecondLevel);
		this.$menuLastContainer = $(this.settings.menuLastLevel);

        this.initialize();
    }

	initialize(){
		var self = this;

		this.$btnCollapse.on('click',this.onClickCollapse);

		$('.'+this.settings.menuLinkClass,this.$menuContainer)
		.on('click',function(event){
			let $link = $(this);

			if($link.data('id')){
				event.preventDefault();
				event.stopPropagation();
			}

			self.onClickMenuLink($link);
		});

		$('.header__menu--list .header__menu--list--item .arrow')
			.on('click',function(event){
				let $link = $(this).parent().find(".header__menu--link");
				self.onClickFirstMenuLink($link);
			});

		$('.header__menu--main-items .header__menu--main-item .arrow')
			.on('click',function(event){
				let $link = $(this)
				.parent()
				.find(".has-sub");
				self.onClickSecondMenuLink($link);
			});

		let $menus = $('.'+this.settings.listClass,this.$menuContainer);
		
		$('.'+this.settings.pageContentClass,this.$menuSecondContainer)
		.removeClass('active')
		.first()
		.addClass('active');

		$('.'+this.settings.pageContentClass + " ul li",this.$menuSecondContainer)
			.removeClass('active')
			.first()
			.find('.header__menu--link')
			.addClass('active');

		$('.'+this.settings.pageContentClass,this.$menuLastContainer)
			.removeClass('active')
			.first()
			.addClass('active');

		$('.'+this.settings.pageLinkClass,this.$menuContainer)
		.removeClass('active')
		.hover(function(event){
			event.preventDefault();
			event.stopPropagation();

			let $link = $(this);
			self.onHoverLink($link);
		});

		$('.'+this.settings.pageSubLinkClass,this.$menuContainer)
		.removeClass('active')
		.hover(function(event){
			event.preventDefault();
			event.stopPropagation();

			let $link = $(this);
			self.onHoverLink($link);
		});




		$('.'+this.settings.pageContentClass+" .has-sub",this.$menuSecondContainer)
			.hover(function(event){
				event.preventDefault();
				event.stopPropagation();

				let $link = $(this);
				self.onHoverSubLink($link);
			});

		$menus.each(function(){
			let $menu = $(this);

			let $links = $('.'+self.settings.pageLinkClass,$menu);
			let $contents = $('.'+self.settings.pageContentClass,$menu);

			$links.first().addClass('active')
			$contents.first().addClass('active');
		})

	}

	onClickMenuLink($link){
		if(!$link.hasClass('current-item')){
			this.$menuContainer.addClass('level-second');

			let id = $link.data('id');
			if(id){
				$(".header__menu--top--item").removeClass('active');
				$link.parent().addClass('active');
				$('.'+this.settings.menuLinkClass,this.$menuContainer)
					.removeClass('current-item');
				$link.addClass('current-item');

				$('.'+this.settings.menuContentClass,this.$menuContainer)
					.removeClass('active');

				let $currentMenuContent = $('.'+this.settings.menuContentClass+'[data-id="'+id+'"]',this.$menuContainer);

				$currentMenuContent
					.addClass('active');

				//activate the first link to have a content
				let $firstLink = $('.'+this.settings.pageLinkClass,$currentMenuContent).first();
				this.onHoverLink($firstLink);
			}
		}else{
			if(window.FFSS.isResponsiveEnable()){
				this.$menuContainer.removeClass('level-second');
				$('.'+this.settings.menuLinkClass,this.$menuContainer).removeClass('current-item');

				$('.'+this.settings.menuContentClass,this.$menuContainer).removeClass('active');
			}
		}
	}

	onClickFirstMenuLink($link){
		if(!this.$menuContainer.hasClass('level-third')) {
			this.$menuContainer.addClass('level-third');
			$('.header__menu--list .header__menu--list--item').removeClass('active');

			$link.parent().addClass('active');
			let currentId = $link.data('id');
			$('.' + this.settings.pageLinkClass, this.$menuContainer)
				.removeClass('active');

			$('.' + this.settings.pageContentClass, this.$menuContainer)
				.removeClass('active');

			let $content = $('.' + this.settings.pageContentClass + '[data-id="' + currentId + '"]', this.$menuContainer);

			$link.addClass('active');
			$content.addClass('active');
		}else{
			this.$menuContainer.removeClass('level-third');
			$('.' + this.settings.pageLinkClass, this.$menuContainer)
				.removeClass('active');

			$('.' + this.settings.pageContentClass, this.$menuContainer)
				.removeClass('active');
		}
	}

	onClickSecondMenuLink($link){
		if(!this.$menuContainer.hasClass('level-four')) {
			this.$menuContainer.addClass('level-four');
			$('.header__menu--main-items .header__menu--main-item').removeClass('active');

			$link.parent().addClass('active');

			let currentId = $link.data('id');
			$('.' + this.settings.pageContentClass, this.$menuLastContainer)
				.removeClass('active');

			$('.' + this.settings.pageContentClass + " ul li a", this.$menuSecondContainer)
				.removeClass('active');

			$('.' + this.settings.pageContentClass + " ul li span", this.$menuSecondContainer)
				.removeClass('active');

			let $content = $('.' + this.settings.pageContentClass + '[data-id="' + currentId + '"]', this.$menuLastContainer);

			$link.closest('.' + this.settings.pageContentClass, this.$menuSecondContainer).addClass('active');

			$link.addClass('active');
			$content.addClass('active');
		}else{
			this.$menuContainer.removeClass('level-four');
			$('.' + this.settings.pageContentClass, this.$menuLastContainer)
				.removeClass('active');

			$('.' + this.settings.pageContentClass + " ul li a", this.$menuSecondContainer)
				.removeClass('active');

			$('.' + this.settings.pageContentClass + " ul li span", this.$menuSecondContainer)
				.removeClass('active');
		}
	}

	onClickCollapse(event){
		$("body").toggleClass('menu-opening');
	}

	onHoverLink($link){

		let currentId = $link.data('id');

		let targetedClass = this.settings.pageLinkClass;
		if($link.hasClass(this.settings.pageSubLinkClass)){
			targetedClass = this.settings.pageSubLinkClass;
		}else{
			$('.'+this.settings.pageContentClass,this.$menuContainer)
			.removeClass('active');
		}

		$('.'+targetedClass,this.$menuContainer)
		.removeClass('active');

		let $content = $('.'+this.settings.pageContentClass+'[data-id="'+currentId+'"]',this.$menuContainer);


		$link.addClass('active');
		$content.addClass('active');

	}

	onHoverSubLink($link){

		let currentId = $link.data('id');
		$('.'+this.settings.pageContentClass,this.$menuLastContainer)
			.removeClass('active');

		$('.'+this.settings.pageContentClass + " ul li a",this.$menuSecondContainer)
			.removeClass('active');

		$('.'+this.settings.pageContentClass + " ul li span",this.$menuSecondContainer)
			.removeClass('active');

		let $content = $('.'+this.settings.pageContentClass+'[data-id="'+currentId+'"]',this.$menuLastContainer);

		$link.closest('.'+this.settings.pageContentClass,this.$menuSecondContainer).addClass('active');

		$link.addClass('active');
		$content.addClass('active');

	}
}

module.exports = Menu;